import { Badge } from "@/components/ui/badge";
import { ShieldCheck, ShieldAlert, Shield } from "lucide-react";

/**
 * Subcontractor reliability badge.
 * Expects the `reliability` object from /api/subcontractors/{id}/reliability
 * or embedded in the listing.
 */
export const ReliabilityBadge = ({ reliability, size = "sm" }) => {
  if (!reliability) return null;
  const { score, level } = reliability;

  const cfg = {
    high: { color: "bg-green-100 text-green-800 border-green-300", Icon: ShieldCheck, label: "Fiable" },
    medium: { color: "bg-amber-100 text-amber-800 border-amber-300", Icon: Shield, label: "À surveiller" },
    low: { color: "bg-red-100 text-red-800 border-red-300", Icon: ShieldAlert, label: "Risque" },
  }[level] || { color: "bg-slate-100 text-slate-700 border-slate-300", Icon: Shield, label: "N/A" };

  const { color, Icon, label } = cfg;
  return (
    <Badge
      variant="outline"
      className={`${color} ${size === "lg" ? "text-sm py-1 px-2" : "text-xs"}`}
      data-testid="reliability-badge"
      title={`Score ${score}/100 — ${reliability.orders_12m || 0} commandes / ${reliability.sav_12m || 0} SAV / ${reliability.negative_events_12m || 0} événements négatifs (12 derniers mois)`}
    >
      <Icon className={`${size === "lg" ? "h-4 w-4" : "h-3 w-3"} mr-1`} />
      {score}/100 • {label}
    </Badge>
  );
};

export default ReliabilityBadge;
